import { Edge, Node } from '@xyflow/react';
import { EDataType } from 'src/modules/network-configuration/models/node-data';
import { NodeModel } from 'src/modules/network-configuration/models/node-model';

import { ImportReviewState } from './import-review-types';

export function getSwitchNodeIds(nodes: Node<NodeModel>[]): string[] {
  // sort nodes by name
  return nodes
    .sort(
      (a, b) =>
        a.data?.category?.name?.localeCompare(b.data?.category?.name || '') ||
        0,
    )
    .filter((n) => n.data?.category?.type === EDataType.Switch)
    .map((n) => n.id);
}

export function getDeviceLikeNodeIds(nodes: Node<NodeModel>[]): string[] {
  return nodes
    .filter((n) => {
      const t = n.data?.category?.type;
      if (!t) return false;
      if (
        t === EDataType.Group ||
        t === EDataType.Note ||
        t === EDataType.Image
      )
        return false;
      if (t === EDataType.ProjectFrame) return false;
      return t !== EDataType.Switch;
    })
    .map((n) => n.id);
}

export function getEdgeIds(edges: Edge[]): string[] {
  return edges.map((e) => e.id);
}

export function allIdsReviewed(
  ids: string[],
  reviewed: Record<string, boolean>,
): boolean {
  if (ids.length === 0) return true;
  return ids.every((id) => reviewed[id]);
}

export function canLeaveStep(
  step: number,
  review: ImportReviewState,
  switchIds: string[],
  deviceIds: string[],
  edgeIds: string[],
): boolean {
  switch (step) {
    case 2:
      return review.vlanSubnetConfirmed;
    case 3:
      return allIdsReviewed(switchIds, review.nodeReviewed);
    case 4:
      return allIdsReviewed(deviceIds, review.nodeReviewed);
    case 5:
      return allIdsReviewed(edgeIds, review.edgeReviewed);
    case 6:
      return review.globalSettingsConfirmed;
    default:
      return true;
  }
}
